import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Entry } from 'contentful';
import { ConnectingToNdcNdcTechnicalFaqPage } from 'src/app/model/page/group/faq/connecting-to-ndc-ndc-commercial-faq-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-connecting-to-ndc-ndc-commercial-faq-page',
  templateUrl: './connecting-to-ndc-ndc-commercial-faq-page.component.html',
  styleUrls: ['./connecting-to-ndc-ndc-commercial-faq-page.component.scss']
})
export class ConnectingToNdcNdcCommercialFaqPageComponent implements OnInit {
  param: number = -1;
  connectingToNdcPage: ConnectingToNdcNdcTechnicalFaqPage = {} as ConnectingToNdcNdcTechnicalFaqPage;
  BackLinkTitle: string = '';
  BackLinkURL: string = '';
  BackLinkIcon: string = '';

  constructor(private activatedRoute: ActivatedRoute, private contentfulService: ContentfulService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'faq-commercial') {
        this.connectingToNdcPage.htmlTitle = title.htmlTitle;
      }
    });
    this.activatedRoute.params.subscribe((params) => (this.param = params['param']));

    this.connectingToNdcPage.sections = [];

    const query = { 'fields.title': 'NDC Commercial FAQ#Connecting to NDC' };
    this.contentfulService.getPageContentWithEntries(query).then((ConnectingToNdcNdcTechnicalFaqPageEntries) => {
      this.mapBanner(ConnectingToNdcNdcTechnicalFaqPageEntries);
      this.mapSections(ConnectingToNdcNdcTechnicalFaqPageEntries);
    });
    this.contentfulService.getPageContentWithItems(query).then((linkItems) => {
      this.BackLinkTitle = linkItems[0]?.fields.constants[0].BackLinkTitle;
      this.BackLinkURL = linkItems[0]?.fields.constants[0].BackLinkURL;
      this.BackLinkIcon = linkItems[0]?.fields.constants[0].BackLinkIcon;
      this.connectingToNdcPage.htmlTitle = linkItems[0].fields.htmlTitle;
    });
  }

  private mapBanner(connectingToNdcPageEntries: Entry<any>[]) {
    connectingToNdcPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let image: any = entry.fields['image'] as string;
    let video: any = entry.fields['video'] as string;
    this.connectingToNdcPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: image.fields.file.url,
      video: video?.fields?.file?.url
    };
  }

  private mapSections(connectingToNdcPageEntries: Entry<any>[]) {
    connectingToNdcPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToSection(entry);
      });

    this.connectingToNdcPage.sections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToSection(entry: Entry<any>) {
    let title: any = entry.fields['title'] as string;
    this.connectingToNdcPage.sections.push({
      title: title.split('#').pop(),
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number
    });
  }
}
